
// @ts-ignore
    import __i18nConfig from '@next-translate-root/i18n'
// @ts-ignore
    import __appWithI18n from 'next-translate/appWithI18n'
// @ts-ignore
    
import React, { useEffect, useState } from 'react';
import dynamic from 'next/dynamic';
import type { AppProps, NextWebVitalsMetric, AppContext } from 'next/app';
import App from 'next/app';

import ContextProvider from '@store/store';
import { fetchConfig, fetchFeatureJson } from '@lib/API/configAPI';
import SharedProvider from '@invideoio/web-shared/context/SharedProvider/SharedProvider';
import { URL_SEARCH_PARAM } from '@invideoio/web-shared/utils/utils.constant';
import ErrorBoundary from '@components/ErrorBoundary';

import '@styles/globals.scss';
import { ConfigType } from '../types';
import { FeatureConfig } from '@invideoio/web-shared/types/Config';

const LoadAnalytics = dynamic(
  () => import('@components/analytics/LoadAnalytics'),
  {
    ssr: false,
  },
);

export function reportWebVitals(metric: NextWebVitalsMetric) {
  if (metric.label === 'web-vital') {
    console.log(`${metric.name}: ${metric.value.toFixed(2)}`);
  }
}

interface RootProps extends AppProps {
  config: ConfigType;
  featureConfig: FeatureConfig;
}

function RootApp({ Component, pageProps, ...otherProps }: RootProps) {
  useEffect(() => {
    /**
     * Need to store affiliate ref from query params in cookie for trackability.
     * Will change this with cookie service.
     **/

    const search_params = window.location.search;

    if (
      search_params !== '' &&
      (search_params.includes(URL_SEARCH_PARAM.REF) ||
        search_params.includes(URL_SEARCH_PARAM.IR_CLICKED) ||
        search_params.includes(URL_SEARCH_PARAM.MP_ID))
    ) {
      // Need to do this here since its replicated on all other repos in a similar way.
      document.cookie =
        window.btoa('query_params') +
        '=' +
        window.location.search +
        '' +
        '; domain=invideo.io' +
        '; path=/';
    }
  }, []);

  return (
    <SharedProvider
      config={{
        RECAPTCHA_KEY: process.env.NEXT_PUBLIC_GOOGLE_CAPTCHA_KEY || '',
        siteConfig: otherProps.config,
        API: {
          ANALYTICS_API: process.env.NEXT_PUBLIC_ANALYTICS_API_URL || '',
          AUTH_API: process.env.NEXT_PUBLIC_AUTH_API || '',
          CORE_API: process.env.NEXT_PUBLIC_API_URL || '',
        },
        APP_ENV: process.env.NEXT_PUBLIC_ENV || 'production',
        CDN_URL: {
          SHARED_URL: process.env.NEXT_PUBLIC_SHARED_CDN_URL || '',
        },
        HOST_URL: process.env.NEXT_PUBLIC_BASE_HOST || '',
        CREATE_PAGE_HOST_URL: process.env.NEXT_PUBLIC_CREATE_PAGE_HOST || '',
      }}
      user={null}
      featureConfig={otherProps.featureConfig}
    >
      <ContextProvider initialState={otherProps as any}>
        <Component {...pageProps} />
        <ErrorBoundary>
          <LoadAnalytics userData={null} />
        </ErrorBoundary>
      </ContextProvider>
    </SharedProvider>
  );
}

RootApp.getInitialProps = async (appContext: AppContext): Promise<any> => {
  // calls page's `getInitialProps` and fills `appProps.pageProps`
  const deviceDetect = require('../middleware/deviceDetect').default;
  const appProps = await App.getInitialProps(appContext);

  try {
    const { os, platform } = await deviceDetect(appContext.ctx);

    const config = await fetchConfig();

    const featureConfig = await fetchFeatureJson();

    const socialLinks = config.social;

    return {
      ...appProps,
      os,
      platform,
      browser: 'chrome',
      socialLinks,
      config,
      featureConfig,
    };
  } catch (error) {
    console.error(error);
    return { ...appProps };
  }
};

const __Page_Next_Translate__ = RootApp;


// @ts-ignore
    export default __appWithI18n(__Page_Next_Translate__, {
// @ts-ignore
      ...__i18nConfig,
// @ts-ignore
      isLoader: true,
// @ts-ignore
      skipInitialProps: false,
// @ts-ignore
      loadLocaleFrom: (l, n) => import(`@next-translate-root/locales/${l}/${n}`).then(m => m.default),
// @ts-ignore
    });
// @ts-ignore
  